import { useState, useEffect, useCallback } from 'react';
import type { BigNumber } from '@segmently/schema-models/entities';
import { BigNumberService } from '@modules/firebase-core/services/BigNumberService';

export function useBigNumbers(projectId: string) {
  const [bigNumbers, setBigNumbers] = useState<BigNumber[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!projectId) return;
    setLoading(true);
    setError('');

    const service = new BigNumberService(projectId);
    const unsub = service.subscribe(
      (data) => { setBigNumbers(data); setLoading(false); },
      (err) => { console.error('Error listening big numbers:', err); setError('Failed to load big numbers.'); setLoading(false); },
    );
    return () => unsub();
  }, [projectId]);

  const createBigNumber = useCallback(async (data: Partial<BigNumber>) => {
    const service = new BigNumberService(projectId);
    return service.create(data);
  }, [projectId]);

  const updateBigNumber = useCallback(async (id: string, data: Partial<BigNumber>) => {
    const service = new BigNumberService(projectId);
    return service.update(id, data);
  }, [projectId]);

  const deleteBigNumber = useCallback(async (id: string) => {
    const service = new BigNumberService(projectId);
    return service.delete(id);
  }, [projectId]);

  return { bigNumbers, loading, error, setError, createBigNumber, updateBigNumber, deleteBigNumber };
}
